import { t } from "i18next"

const Validations = () => ({
    name: (errors, value) => {
        if (!value) {
            errors.name = (t("Required field", {ns: "messages"}));
          } else if (
            !/^[a-zA-Zа-яА-Я]{2,16}$/g.test(
                value
            )
          ) {
            errors.name = (t("Invalid name format", {ns: "messages"}));
        }
    },
    phone: (errors, value) => {
        if(!value) {
            errors.phone = (t("Required field", {ns: "messages"}));
        } else if(value.length < 11){
            errors.phone = (t("Invalid number format", {ns: "messages"}));
        }
    },
    itn: (errors, value) => {
          if(!value) {
            errors.itn = (t("Required field", {ns: "messages"}));
          } else if(value.toString().length < 10 || value.toString().length > 10 ) {
            errors = (t("Invalid itn format", {ns: "messages"}));
          }
    },
    email: (errors, value) => {
      if(!value) {
        errors.email = (t("Required field", {ns: "messages"}));
      } else if(!/^[a-zA-Zа-яА-Я0-9_.+-]+@[a-zA-Zа-яА-Я0-9-]+\.[a-zA-Zа-яА-Я0-9-.]+$/gm.test(value)) {
        errors.email = (t("Invalid email format", { ns: "messages" }));
      }
    },
    password: (errors, value) => {
      if(!value) {
        errors.password = (t("Required field", {ns: "messages"}));
      } else if(value.length < 6) {
        errors.password = "Пароль должен содержать не меньше 6 символов";
      }
    },
    role: (errors, value) => {
      if(!value) {
        errors.role = (t("Required field", {ns: "messages"}));
      }
    },
    companyName: (errors, value) => {
      if(!value) {
        errors.companyName = (t("Required field", {ns: "messages"}));
      }
    }
});

export default Validations;